import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { Box, Typography, makeStyles, Theme, createStyles } from '@material-ui/core';
import Client from '@spike/client-model';
import { fetchClientsThunk } from '@spike/clients-action';
import { Button, SelectionBar } from 'components/UI';
import { useApiClientWrapper } from 'hooks';
import { FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import { reduceResolution, wbp } from 'Theme';
import { Option } from '@spike/model';

export interface Props {
    className?: string;
    chatSearchActive?: boolean;
    receiverType: 'prospect' | 'customer';
    onNewChatRequest: (chatSearchActive?: boolean) => void;
    setReceiverType: (receiverType: 'prospect' | 'customer') => void;
}

const options: Option<string>[] = [
    {
        id: 'customer',
        name: 'Clients'
    },
    {
        id: 'prospect',
        name: 'Unknown'
    }
];

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
            flexDirection: 'column'
        },
        title: {
            display: 'flex',
            alignItems: 'center',
            [theme.breakpoints.down(wbp)]: {
                marginBottom: `${reduceResolution(20)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginBottom: '20px'
            }
        },
        selectorBar: {
            marginBottom: '20px'
        },
        titleColumn: {
            [theme.breakpoints.down(wbp)]: {
                marginRight: `${reduceResolution(30)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginRight: '30px'
            },

            '& p': {
                margin: 0,
                fontSize: 24,
                lineHeight: 1,
                fontWeight: 600
            }
        },
        btnColumn: {
            'marginLeft': 'auto',
            '& a': {
                textDecoration: 'none'
            }
        },
        button: {
            'padding': '0px 20px',
            '& .MuiButton-startIcon': {
                '& svg': {
                    width: 16,
                    height: 16,
                    [theme.breakpoints.down('lg')]: {
                        width: 14,
                        height: 14
                    }
                }
            },
            '& span': {
                fontSize: 18,
                fontWeight: 600
            },
            [theme.breakpoints.down('lg')]: {
                'height': 39,
                'padding': '0px 20px',
                '& span': {
                    fontSize: 14,
                    fontWeight: 600
                }
            }
        }
    })
);

export const Header: FunctionComponent<Props> = props => {
    const dispatch = useDispatch();
    const apiClientWrapper = useApiClientWrapper();
    const classes = useStyles();

    const unreadCount = useSelector<RootState, number>(state => state.twoWaySms.messageAmount);

    const handleNewChatRequest = () => {
        props.onNewChatRequest && props.onNewChatRequest(false);
    };

    return (
        <Box className={classes.root}>
            <Box className={classes.title}>
                <Box className={classes.titleColumn}>
                    <Typography>Inbox ({unreadCount})</Typography>
                </Box>
                <Box className={classes.btnColumn}>
                    <Button
                        className={classes.button}
                        color="orange"
                        size="medium"
                        startIcon={faPlus}
                        label="New Chat"
                        onClick={handleNewChatRequest}
                    />
                </Box>
            </Box>
            <SelectionBar
                className={classes.selectorBar}
                options={options}
                selectedId={props.receiverType}
                onSelect={(id: string) => props.setReceiverType(id as 'prospect' | 'customer')}
            />
        </Box>
    );
};

export default Header;
